import { Injectable } from '@angular/core';
import { WindowService } from './window.service';

@Injectable()
export class ScrollToService {

  constructor(private _window: WindowService) { }

  goTop() {
    this.goTo();
  }

  goTo(x = 0, y = 0) {
    const { setTimeout, scrollTo } = this._window.nativeWindow;
    setTimeout(() => scrollTo(x, y), 10);
  }
}
